<template>
  <div class="page">
    <b-jumbotron fluid>
      <h1 class="h3">Walne Zebranie Użytkowników - 23 kwietnia 2026</h1>
    </b-jumbotron>

    <div class="container">
      <h2 class="h3 pb-2 mb-3 border-bottom">Zaproszenie</h2>
      <p>
        Społeczny Komitet Parkingowy zaprasza serdecznie na Walne Zebranie Użytkowników w dniu
        <b>23 kwietnia (czwartek), o godzinie 19:00</b>.<br />
        Zebranie odbędzie się w
        <a href="https://maps.app.goo.gl/gjUF53NTfrPKvYqr6" target="_blank"
          >Klubie Nugat, ul. Nugat 4.</a
        >
      </p>
      <p>
        <b>Zapraszamy Państwa do:</b>
      </p>
      <ul>
        <li>
          zgłaszania projektów uchwał oraz propozycji spraw do porządku obrad (nie później niż na 3
          dni przed Zebraniem)
        </li>
        <li>
          zgłaszania kandydatur do wyborów uzupełniających do Społecznego Komitetu Parkingowego.
        </li>
      </ul>

      <h2 class="h3 pb-2 mb-3 border-bottom">Porządek obrad</h2>
      <ol>
        <li>Otwarcie obrad i odczytanie listy pełnomocnictw.</li>
        <li>
          Stwierdzenie prawidłowości zwołania Zebrania oraz jego zdolności do podejmowania uchwał.
        </li>
        <li>Podjęcie uchwały w sprawie przyjęcia porządku obrad.</li>
        <li>
          Rozpatrzenie i zatwierdzenie sprawozdania Społecznego Komitetu Parkingowego z działalności
          od dnia 14 grudnia 2019 do dnia 23 kwietnia 2026.
        </li>
        <li>
          Rozpatrzenie i zatwierdzenie propozycji zmiany w Regulaminie Parkingu Społecznego w
          kwestii ilości miejsc postojowych wykorzystywanych przez jednego Użytkownika.
        </li>
        <li>
          Rozpatrzenie i zatwierdzenie propozycji zmiany w Regulaminie Parkingu Społecznego w
          kwestii wymogu posiadania pojazdu przez Użytkownika.
        </li>
        <li>
          Rozpatrzenie i zatwierdzenie propozycji zmiany w Regulaminie Parkingu Społecznego w
          kwestii dopuszczenia postoju wyłącznie pojazdów będących w bieżącym użytkowaniu.
        </li>
        <li>
          Rozpatrzenie i zatwierdzenie propozycji zmiany w Regulaminie Parkingu Społecznego w
          kwestii utraty prawa do miejsca postojowego w przypadku braku aktywnego użytkowania.
        </li>
        <li>
          Rozpatrzenie i podjęcie uchwały w sprawie stałej składki społecznej na utrzymanie
          parkingu.
        </li>
        <li>
          Rozpatrzenie i podjęcie uchwały w sprawie stałej składki społecznej za obsługę parkingu.
        </li>
        <li>Wybory uzupełniające do Społecznego Komitetu Parkingowego.</li>
        <li>Rozpatrzenie i podjęcie wniosków Użytkowników parkingu.</li>
        <li>Zamknięcie Walnego Zebrania.</li>
      </ol>

      <h2 class="h3 pb-2 mb-3 border-bottom">Projekty uchwał</h2>

      <a href="/files/walne-2026/2026-walne-porządek-obrad-uchwały.pdf" target="_blank">
        <i class="fa fa-file-pdf"></i> Projekty uchwał
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'walne-2026',
};
</script>
